import { AxiosResponse } from "axios"
import { QueryKey, useQueryClient } from "react-query"

export const useGetQueryData = <T>(queryKey: QueryKey) => {
  const queryClient = useQueryClient()

  return queryClient.getQueryData<AxiosResponse<T>>(queryKey)
}
